
import { language as lan_cartList } from "./list";
import { language as lan_cartprogressbar } from "./progressbar";
import { language as lan_cartcoupon } from "./coupon";
let language = {
    ...lan_cartList,
    ...lan_cartprogressbar,
    ...lan_cartcoupon,
    A105B001: "您确定要删除这个购物车项目吗?点击[确定]删除该商品，点击[取消]取消购物车商品的删除。 ",
    A105B002: "删除购物车项目",
    CARTITEM_QTY_TIP_TITLE:"购买数量限制",
    CARTITEM_QTY_TIP_TEXT:"{{qtyTip}}",
    CART_ISSUE_PAGE_LOADING_TITLE: "购物车页面加载异常",
    CART_ERROE_PAGE_LOADING_TITLE: "购物车页面加载错误",
    CART_ISSUE_PAGE_LOADING_CONTENT: "加载购物车页面时发生问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    CART_ITEM_PRICE_UPDATE_ISSUE_TITLE: "购物车产品更新异常",
    CART_ITEM_PRICE_UPDATE_ERROE_TITLE: "购物车产品更新错误",
    CART_ITEM_PRICE_UPDATE_ISSUE_CONTENT: "更新购物车商品价格时出现问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    CART_ITEM_QTY_UPDATE_ISSUE_TITLE: "数量更新异常",
    CART_ITEM_QTY_UPDATE_ERROR_TITLE: "数量更新错误",
    CART_ITEM_QTY_UPDATE_ISSUE_CONTENT: "更新产品数量时出现问题。 请刷新页面再试一次。 如果问题仍然存在，请随时与我们的支持团队联系 {{supportmail}}。",
    CART_CURRENCY_CONFIG_MISSING_CONTENT:" {{appName}}货币设置错误。” 请刷新页面并点击\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币。 如果问题仍然存在，请联系{{serviceEmail}}。",
    CART_CURRENCY_NONSUPPORT_CONTENT:"不支持您选择的货币。 请按\“{{updateCurrencyBtn}}\”更新{{appName}}显示货币",
    A105B300310:"系统中不存在货币 {{currentCurrency}}。",
    A105B3000601: "当前货币: {{currentCurrency}}, {{appName}}平台支持的货币类型：: {{supportCurrencies}}。",
}

export { language }